var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import PropTypes from "prop-types";
import Dropzone from "react-dropzone";
import { Col, FormGroup, FormControl, InputGroup } from "react-bootstrap";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
import { ValidationInput } from "@irati/utils/validation";
import Button from "../Button";
import ErrorText from "../ErrorText";
import HintText from "../HintText";
var File = /** @class */ (function (_super) {
    __extends(File, _super);
    function File(props, context) {
        var _a;
        var _this = _super.call(this, props, context) || this;
        _this.state = {
            errorMsg: null,
            value: ((_a = props.file) === null || _a === void 0 ? void 0 : _a.name) || ""
        };
        _this.validation = new ValidationInput(_this);
        return _this;
    }
    File.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        if (nextProps.file) {
            this.setState({ value: nextProps.file.name });
        }
    };
    File.prototype.componentDidUpdate = function (prevProps, prevState) {
        this.validation.update(prevProps, prevState);
    };
    File.prototype.componentWillUnmount = function () {
        this.validation.destroy();
    };
    File.prototype.render = function () {
        var _a = this.props, hintText = _a.hintText, maxFiles = _a.maxFiles, name = _a.name, formatMessage = _a.formatMessage, label = _a.label, onChange = _a.onChange, type = _a.type;
        var _b = this.state, errorMsg = _b.errorMsg, value = _b.value;
        return (React.createElement(FormGroup, { controlId: name },
            React.createElement(Col, { sm: 12 }, label),
            React.createElement(Dropzone, { name: "file", accept: type, maxFiles: maxFiles, className: "dropzone-" + name, onClick: onChange, onDrop: onChange },
                React.createElement(Col, { sm: 12 },
                    React.createElement(InputGroup, null,
                        React.createElement(FormControl, { disabled: true, type: "text", value: value }),
                        React.createElement(InputGroup.Button, null,
                            React.createElement(Button, { marginLeft: 2, onClick: onChange },
                                React.createElement(FormattedMessage, { id: "admin.components.samlSingleSignOn.file.button.chooseFile" }))))),
                React.createElement(Col, { sm: 12 },
                    React.createElement("div", null,
                        React.createElement(HintText, { small: true }, formatMessage({ id: hintText }))))),
            errorMsg && (React.createElement(Col, { sm: 12 },
                React.createElement(ErrorText, { small: true }, errorMsg)))));
    };
    File.contextTypes = {
        currentScreen: PropTypes.string
    };
    File.defaultProps = {
        type: "text",
        hintText: "admin.components.samlSingleSignOn.file.hintText",
        maxFiles: 1
    };
    return File;
}(Component));
export default injectIntl(File);
